// extracted by mini-css-extract-plugin
module.exports = {"container":"CentriMufe_container___nwin","mufeBox":"CentriMufe_mufeBox__3p7Qz"};